
import { SaleEditState } from "@/utils/sale-edit/sale-edit-state";
import Vue from "vue";
import AppFrequencySettingsEdit from "./FrequencySettingsEdit.vue";

export default Vue.extend({
	props: {
		state: {
			type: Object as () => SaleEditState,
			required: true
		}
	},
	components: {
		AppFrequencySettingsEdit
	}
});
